<template>
  <router-view />
</template>

<script setup>
import GuestLayoutViewModel from "@/viewmodels/layouts/GuestLayoutViewModel";
new GuestLayoutViewModel();
</script>
